module.exports = __webpack_public_path__ + "static/media/crocodile(7).c76a1ce0.PNG";